import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { IonicPage, NavController, NavParams,
  AlertController,Platform,ModalController } from 'ionic-angular';
import { ClientesEditarPage } from '../../pages/clientes-editar/clientes-editar'
import { ClientesProvider } from '../../providers/clientes/clientes'
import { ClientesCorreosElectronicosEditarPage } from '../../pages/clientes-correos-electronicos-editar/clientes-correos-electronicos-editar'
import { clientesCorreos } from '../../models/clientesCorreos';
import { ClientesCorreosProvider } from '../../providers/clientes-correos/clientes-correos'
import { clientesTelefonos } from '../../models/clientesTelefonos';
import { ClientesTelefonosProvider } from '../../providers/clientes-telefonos/clientes-telefonos'
import { ClientesTelefonosEditarPage } from '../clientes-telefonos-editar/clientes-telefonos-editar';
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { trigger, state, style, transition, animate} from '@angular/animations';
import { Storage } from '@ionic/storage'
import { UtilsProvider } from '../../providers/utils/utils'
import { NUBE_AWS } from '../../config/url.servicio';
import { Observable } from 'rxjs/Observable';
import { EntidadesProvider } from '../../providers/entidades/entidades';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import { CajaProvider } from '../../providers/caja/caja';
import { FormGroup } from '@angular/forms';
import { PushProvider } from '../../providers/push/push';
import { CallcenterProvider } from '../../providers/callcenter/callcenter';
import { InformesProvider } from '../../providers/informes/informes';

@IonicPage()
@Component({
  selector: 'page-clientes',
  templateUrl: 'clientes.html',
  providers: [ AuthService, ParametrosGeneralesRedux, EntidadesProvider,PushProvider, CallcenterProvider ],
  animations: [
    trigger('openClose', [
        state('collapsed, void', style({height:'0px'})),
        state('expanded', style({height:'*'})),
        transition('collapsed <=> expanded',[animate(300,style({height:'*'})),
            animate(300)])

    ])
]
})
export class ClientesPage implements OnInit {
  peticion: string = "clientes";
  visibled:boolean = true;
  tipoIdentificacion:string =""
  identificacion:string =""
  digito:string =""
  fechaExpedicion:string =""
  primerApellido:string =""
  segundoApellido:string =""
  primerNombre:string =""
  segundoNombre:string =""
  nombreCompleto:string =""
  fechaIngreso:string =""
  estado:string =""
  clientes:any[]=[]
  clientesCopia:any[]=[]

  ClientesCorreos:any[]=[]
  ClientesCorreosData:any[]=[]
  correoElectronico:string =""
  clienteId:string =""
  clientesId:number=0
  @Input() clientesIdCallcenter: any;
  id:string =""
  entidadesId:any
  ClientesTelefonos:any[]=[]
  ClientesTelefonosData:any[]=[]
  numeroTelefono:string =""
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  Valordirecciones:any =""
  public formState: string = 'collapsed'
  public formStatebool:boolean= false
  buscar: any = "";
  allItems: any;
  public page: number = 0;
  public search: string = '';
  public field: string = 'nombreCompleto';
  companiasId;
  usuariosId
  fechaNacimiento: string;
  edad: number;
  foto: any;
  genero: string;
  habilitarParaCredito: boolean;
  empresa: string;
  cargo: string;
  salario: number;
  mostrarGrid = false
  buscarTexto = ""
  dataclienteFiltro:any[] = []
  referenciaForm: FormGroup;
  parentezcosId = 0
  parentescos: any[] = [
    {
      id: 11,
      nombre: 'AMIGOS'
    }
    ,
    {
      id: 12,
      nombre: 'OTROS'
    },
    {
      id: 13,
      nombre: 'PAREJA'
    },
    {
    id: 1,
    nombre: 'HERMANO'
  },
  {
    id: 2,
    nombre: 'CUÑADO'
  },
  {
    id: 3,
    nombre: 'ESPOSA'
  },
  {
    id: 4,
    nombre: 'ESPOSO'
  },
  {
    id: 5,
    nombre: 'HIJO'
  },
  {
    id: 6,
    nombre: 'PADRE'
  },
  {
    id: 7,
    nombre: 'MADRE'
  },
  {
    id: 8,
    nombre: 'ABUELO'
  },
  {
    id: 9,
    nombre: 'TIO'
  },
  {
    id: 10,
    nombre: 'PRIMO'
  }];

  nombre:string = ""
  habitoDePago:string = "S"
  clientesReferenciasFamiliares = []
  clientesreferenciasComerciales = []
  clientesreferenciasComercialesVarios = []
  numeroTelefono2:string = ""
  numeroTelefono2ReferenciaFamiliar:string = ""
  numeroTelefonoReferenciaFamiliar:string = ""
  interesCreditos:any = []
  creditosBoolean = false
  clientesDetalles = []
  historico:string = ""
  iniciaCon:string = ""
  fechaDeInicio:string = ""
  actualmenteTiene:string = ""
  referenciasComerciales:boolean = false
  comercio:string = ""
  cantidadPorPagina: number = 10; // La cantidad de registros por página anteriormente tenia 100
  totalPaginas: number = Infinity;
  paginaActual: number = 1; // Página actual
  cargando: boolean = false;
  progreso: number = 0;
  barraVisible: boolean = false;
  @Input() showHeader: boolean = true;
  montoAprobado: number = 0;
  montoAprobadoFinal:number = 0;
  tieneNovedad:  string = 'N';
  tieneNovedadTexto: string = 'No';
  tieneNovedadComercial: string = 'N';
  tieneNovedadComercialTexto: string = 'N';
  tieneNovedadReferenciaFamiliar:  string = 'N';
  tieneNovedadTextoReferenciaFamiliar: string = 'No';
  tieneCupoAprobado:  string = 'N';
  tieneCupoAprobadoTexto: string = 'No';
  cupoAprobado: number = 0;
  isFocused: boolean = false;
  formattedSalario: string;
  datosCreditos: any = []
  descripcionCupoAprobado:string = ''
  clientesReferenciasFamiliaresId:any = undefined
  clientesReferenciasComercialesVariosId:any = undefined
  clienteDescripcion:string=''
  constructor(public navCtrl: NavController, public navParams: NavParams,
             public alertControllers:AlertController,
            public servicioCliente:ClientesProvider,
            public platforms:Platform,
            public modalControllers:ModalController,
            public servicioClienteCorreo:ClientesCorreosProvider,
            public servicioClienteTelefono:ClientesTelefonosProvider ,
            public servicioCompania:CompaniasProvider,
            public auth: AuthService,
            public storages:Storage,
            public utilidades:UtilsProvider,
            public servicioEntidades: EntidadesProvider,
            public utilsParametrosGeneralesRedux: ParametrosGeneralesRedux,
            public servicio:CajaProvider,
            public push:PushProvider, private cd: ChangeDetectorRef,
            public callcenterProvider: CallcenterProvider,
            public servicioDescargar: InformesProvider
            ) {
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','usuariosId','companiasId'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                    this.usuariosId = val['usuariosId']
                  }
                })

              let valor = this.navParams.get('data')


              this.buscarDatosIniciales()
              this.buscarValoresCliente()
  }

  async ngOnInit() {
    let companiasId = localStorage.getItem('companiasId'); // Recuperar de localStorage
    let clientesIdCallcenter = localStorage.getItem('clientesIdCallcenter'); // Recuperar de localStorage
    if (clientesIdCallcenter && companiasId) {
      this.iniciarLogicaConClientesId(companiasId, clientesIdCallcenter);
    }
    this.buscarIntereses(companiasId)
    this.parametrosGenerales()
    this.cargarServicioCliente()
  }

  ionViewDidLoad() {
    this.cargarClientesPaginados();
  }

  async parametrosGenerales() {
    let companiasId = await localStorage.getItem('companiasId')
    let usuariosId =  await localStorage.getItem('usuariosId')
    this.push.buscarParametrosGeneralesConUsuario(companiasId,usuariosId).subscribe((data)=>{
      if(NUBE_AWS) {
        let valuesData = JSON.parse(data['_body']).data[0][0]
        this.referenciasComerciales = valuesData.referenciasComerciales === 'S' ? true : false;
      }
    })
  }

  async buscarDatosIniciales() {
    let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
    if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
      this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
    } else {
      this.storages.get('companiasId').then((val) => {
        this.companiasId = val
      })
    }
  }

  toggleForm(){
    this.formState = (this.formState == 'collapsed') ? 'expanded' : 'collapsed'
    this.formStatebool = !this.formStatebool
}
label(){
    return (this.formState == 'collapsed') ? 'Agregar campos adicionales' : 'Ocultar campos adicionales'
}
icon(){
  return (this.formState == 'collapsed') ? 'arrow-dropright-circle' : 'arrow-dropleft-circle'
}

  // ionViewDiadLoad(){
  //   this.cargarServicioCliente()

  // }

  // ionViewWillEnter() {
  //   this.cargarServicioCliente()

  // }

  guardar(){
    this.guardarServicioCliente()
  }

  editarClientes(clientes:any){
    let modal = this.modalControllers.create(ClientesEditarPage, {clientes})
    modal.present();

    modal.onDidDismiss(data => {

      if (data) {
        //let fechaExpedicion = data.fechaExpedicion
        //fechaExpedicion = this.servicioCliente.formatearCadena(fechaExpedicion)
        // let fechaIngreso = data.fechaIngreso
        // fechaIngreso  = this.servicioCliente.formatearCadena(fechaIngreso)
        //data.fechaExpedicion = fechaExpedicion
        // data.fechaIngreso = fechaIngreso
        // if(fechaIngreso ="--"){
        //   data.fechaIngreso = "1900-01-01"
        //   data.fechaExpedicion = "1900-01-01"
        //   this.estado = "A"
        // }
        data.nombreCompleto = `${data.primerNombre} ${data.segundoNombre} ${data.primerApellido} ${data.segundoApellido} `
        data.Valordirecciones = this.Valordirecciones
        data.numeroTelefono = data.numeroTelefono
        data.tipoIdentificacion = data.tipoIdentificacion.toUpperCase()
        data['usuariosId'] = this.usuariosId == undefined ? 0 : this.usuariosId;
        this.storages.get('companiasId').then((val) => {
          data['companiasId']  = val
        this.servicioCliente.actualizar(data)
        .subscribe(
            res => {
              this.utilidades.mensajeMuestro('CLIENTES','Modificado Exitosamente!','success')
              this.clientes = []
              this.cargarServicioCliente()
            },
            err => console.log(err)
          )

        })

      }

    })

  }



editarRegistros(originalTodo: any, modificadoTodo: any){
    const index = this.clientes.indexOf(originalTodo);

        this.clientes = [
          ...this.clientes.slice(0,index),
          modificadoTodo,
          ...this.clientes.slice(index + 1)
        ]
        this.clientes = []
        this.cargarServicioCliente();
}


  eliminarClientes(todo:any){
    // this.clientes.splice(todo,1);
    // this.guardarStorage();
    let clientes = []
    clientes['queHago'] = "E"
    clientes['name'] = "dataDynamicCrud"
    clientes['nombreTabla'] = "clientes"
    clientes['clientesId'] = todo.clientesId
    clientes['usuariosId'] = this.usuariosId == undefined ? 0 : this.usuariosId;
    this.utilidades.mensajeConfirmacionDos('CLIENTES','¿Está seguro de eliminar el Cliente?','question','Si','No')
    .then((eliminacliente: boolean) => {
      if(eliminacliente){
        this.servicioCliente.eliminar(clientes)
        .subscribe(
          res => {
            this.utilidades.mensajeMuestro('CLIENTES','Cliente eliminado con éxito!','success')
            this.clientes = []
            this.cargarServicioCliente()
          },
          err => console.log(err)
        )
      }
      else {
        this.utilidades.mensajeMuestro('CLIENTES','No se eliminó el registro','warning')
      }

    })

  }


  private guardarServicioCliente(){

    let fechaExped = this.fechaExpedicion
    fechaExped = this.servicioCliente.formatearCadena(this.fechaExpedicion)
    const currentDate = new Date();
    let fechaIng = currentDate.toISOString().substring(0, 10);

    // this.fechaIngreso = currentDate.toISOString().substring(0, 10);
    fechaIng  = this.servicioCliente.formatearCadena(this.fechaIngreso)
    if(fechaIng ="--"){
      fechaIng = "1900-01-01"
      fechaExped = "1900-01-01"
      this.estado = "A"
    }

    let datosCliente: any = {
      tipoIdentificacion : this.tipoIdentificacion.toUpperCase(),
      identificacion : this.identificacion,
      digito : this.digito,
      fechaExpedicion : fechaExped,
      primerApellido : this.primerApellido,
      numeroTelefono : this.numeroTelefono,
      numeroTelefono2: this.numeroTelefono2,
      segundoApellido : this.segundoApellido,
      primerNombre : this.primerNombre,
      segundoNombre : this.segundoNombre,
      nombreCompleto : `${this.primerNombre} ${this.segundoNombre} ${this.primerApellido} ${this.segundoApellido} ` ,
      fechaIngreso : fechaIng,
      estado : this.estado,
      direccion : this.Valordirecciones,
      queHago: "I",
      nombreTabla: "clientes",
      name: "dataDynamicCrud",
      correoElectronico: this.correoElectronico,
      entidadesId: this.entidadesId && this.entidadesId.length > 0 ? this.entidadesId[0].value : 0,
      fechaNacimiento: this.fechaNacimiento == undefined ? '1900-01-01' : new Date(this.fechaNacimiento),
      edad: this.edad == undefined ? 0 : this.edad,
      habilitarParaCredito: this.habilitarParaCredito === true ? '1' : '0',
      empresa: this.empresa == undefined ? '' : this.empresa,
      cargo: this.cargo == undefined ? '' : this.cargo,
      salario: this.salario == undefined ? 0 : this.salario
    }
    this.storages.get('companiasId').then((val) => {
      datosCliente['companiasId']  = val
      datosCliente['usuariosId'] = this.usuariosId == undefined ? 0 : this.usuariosId;
      let identificacion = datosCliente.identificacion
    this.servicioCliente.guardar(datosCliente)
      .subscribe(
      (res:any) => {
        let buscarCliente = this.interesCreditos.length>0 ? true : false
        if(buscarCliente) {
          this.servicioCliente.buscarClientesPorIdentificacion(val,identificacion)
          .subscribe(
          (datos:any) => {
            this.clientesDetalles = !NUBE_AWS ? datos : JSON.parse(datos['_body']).data[0]
            if(this.clientesDetalles.length>0) {
              this.cargarDetallesClientes(this.clientesDetalles)
            }
            this.utilidades.mensajeMuestro('CLIENTES','Guardado Exitosamente!','success')
            this.cargarServicioCliente()
          },(err)=> console.log(err))
        } else{
          this.limpiarClientes()
          this.utilidades.mensajeMuestro('CLIENTES','Guardado Exitosamente!','success')
          this.cargarServicioCliente()
        }
      },
      err => {

        console.log(err)}
      )
    })

    this.tipoIdentificacion =""
    this.identificacion =""
    this.digito =""
    this.fechaExpedicion =""
    this.primerApellido =""
    this.segundoApellido =""
    this.primerNombre =""
    this.segundoNombre =""
    this.nombreCompleto =""
    this.fechaIngreso =""
    this.estado =""
    this.Valordirecciones = ""
    this.numeroTelefono = ""
    this.numeroTelefono2 = ""
    this.correoElectronico = ""
    this.fechaNacimiento=""
    this.edad=0
    this.foto=""
    this.genero=""
    this.habilitarParaCredito=false
    this.empresa=""
    this.cargo=""
    this.salario=0
    this.formattedSalario = ''

setTimeout(()=>{
    // this.servicioCliente.buscar()
    // .subscribe((data) => {

    //   this.clientes = data
    // }, error => {
    //   console.log(error)
    // })
    this.cargarServicioCliente()
  },2000)


    }


      // cargarServicioCliente(){
      //   this.storages.get('companiasId').then((val) => {
      //     this.servicioCliente.buscarClientesPorEmpresa(val)
      //       .subscribe((data) => {
      //       this.entidadesId = []
      //       this.clientes = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
      //     }, error => {
      //       console.log(error)
      //     })
      //   })
      // }

      // cargarServicioCliente(){
      //   this.storages.get('companiasId').then((val) => {
      //     let companiasId = 11
      //     this.servicioCliente.buscarClientesPorEmpresa(companiasId)
      //       .subscribe((data) => {
      //       this.entidadesId = []
      //       this.clientes = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
      //     }, error => {
      //       console.log(error)
      //     })
      //   })
      // }

      cargarServicioCliente(){
        // this.buscarClientesPorEmpresa()
        this.cargarClientesPaginados(); // Llama al método de carga


      }


      ubicacion(queHago:string){

        switch (queHago) {
          case 'clientes': {
          this.ClientesCorreos = []
          this.ClientesCorreosData = []
          this.cargarServicioCliente()
          break;
        }
          case 'correos': {
            this.cargarServicioClienteCorreo()
            break;
          }
          case 'direcciones': {
            this.clientes = []
            break;
          }
          case 'telefonos': {
            this.cargarServicioClienteTelefono()
            this.clientes = []
            this.ClientesCorreos = []
            this.ClientesCorreosData = []
            break;
          }
          case 'referenciasfamiliares': {
            this.buscarValoresCliente()
            this.clientes = []
            this.ClientesCorreos = []
            this.ClientesCorreosData = []
            break;
          }

        }
      }


      guardarCorreo(){

            for(var i = 0; i < this.ClientesCorreos.length; i++) {
                if (this.ClientesCorreos[i].clientesId ==  this.ClientesCorreos['clientesId']) {
                  this.nombreCompleto = this.ClientesCorreos[i].nombreCompleto
                  let valor:clientesCorreos = {
                    clientesId: this.ClientesCorreos['clientesId'],
                    correoElectronico: this.correoElectronico,
                    queHago: "I",
                    nombreTabla: "clientesCorreosElectronicos",
                    name: "dataDynamicCrud"
                    }
                    valor['usuariosId'] = this.usuariosId == undefined ? 0 : this.usuariosId;
                    this.servicioClienteCorreo.guardar(valor)
                    .subscribe(
                      res => {
                        this.actualizarValores()
                      },
                      err => console.log(err)
                      )
                    break;
                }
          }
        }


          editarclientesCorreosElectronicos(ClientesCorreosData:any){
            let modal = this.modalControllers.create(ClientesCorreosElectronicosEditarPage, {ClientesCorreosData:ClientesCorreosData})
            modal.present();

            modal.onDidDismiss( data => {
              if(data){
                this.editarRegistrosCorreo(ClientesCorreosData, data);
              }

            })

          }

        editarRegistrosCorreo(originalTodo: any, modificadoTodo: any){
            const index = this.ClientesCorreosData.indexOf(originalTodo);

                this.ClientesCorreosData = [
                  ...this.ClientesCorreosData.slice(0,index),
                  modificadoTodo,
                  ...this.ClientesCorreosData.slice(index + 1)
                ]
                modificadoTodo.queHago = "A"
                modificadoTodo.nombreTabla = "clientesCorreosElectronicos"
                modificadoTodo.name = "dataDynamicCrud"
                modificadoTodo['usuariosId'] = this.usuariosId == undefined ? 0 : this.usuariosId;
               this.servicioClienteCorreo.actualizar(modificadoTodo)
               .subscribe(
                res => {
                  this.actualizarValores()
                  this.cargarServicioClienteCorreo()
                },
                err => {
                  console.log(err)}
              )
        }


          eliminarClientesCorreosElectronicos(todo:any){
            this.ClientesCorreosData.splice(todo,1);
            this.servicioClienteCorreo.eliminar(this.ClientesCorreosData)
            let clienteCorreos = []
            clienteCorreos['queHago'] = "E"
            clienteCorreos['name'] = "dataDynamicCrud"
            clienteCorreos['nombreTabla'] = "clientes"
            clienteCorreos['clientesCorreosElectronicosId'] = todo.clientesCorreosElectronicosId
            clienteCorreos['usuariosId'] = this.usuariosId == undefined ? 0 : this.usuariosId;
            this.servicioClienteCorreo.eliminar(clienteCorreos)
            .subscribe(
              res => {
                this.actualizarValores()
                this.cargarServicioClienteCorreo()
              },
              err => console.log(err)
            )

          }


                  cargarServicioClienteCorreo(){
                    this.servicioCliente.buscar()
                    .subscribe((data) => {
                      this.ClientesCorreos = data
                      this.clientes =  []
                      this.servicioClienteCorreo.buscar()
                        .subscribe((datos)=>{
                          this.ClientesCorreosData = !NUBE_AWS ? datos : JSON.parse(datos['_body']).data[0]
                          for(var i = 0; i < data.length; i++){
                            var k = 0
                            if(datos.length>0){
                              for(k < datos.length && datos.length > 0;;){

                                if(datos[k]['clientesId'] === data[i]['clientesId']){
                                  this.ClientesCorreosData[k]['nombreCompleto'] =  data[i]['nombreCompleto']
                                }
                                if(k + 1< datos.length){
                                  k = k + 1
                                }else{
                                  break;
                                }

                              }
                          }
                          }




                        }, error => {
                          console.log(error)
                        })
                    }, error => {
                      console.log(error)
                    })
                  }
                      valorBuscado(dato) {

                        if(dato.clientesId ===this.ClientesCorreos['clientesId']){
                          return dato.nombreCompleto
                        }
                    }

          actualizarValores() {
            this.ClientesCorreosData = []
            this.correoElectronico = ""
            this.ClientesCorreos = []
            this.ClientesCorreos['clientesId'] = 0
            this.cargarServicioClienteCorreo()

          }

          guardarTelefono(){

                for(var i = 0; i < this.ClientesTelefonos.length; i++) {
                    if (this.ClientesTelefonos[i].clientesId ==  this.ClientesTelefonos['clientesId']) {
                      this.nombreCompleto = this.ClientesTelefonos[i].nombreCompleto
                      let valor:clientesTelefonos = {
                        clientesId: this.ClientesTelefonos['clientesId'],
                        numeroTelefono: this.numeroTelefono,
                        queHago: "I",
                        nombreTabla: "clientesTelefonos",
                        name: "dataDynamicCrud"
                        }
                        valor['usuariosId'] = this.usuariosId == undefined ? 0 : this.usuariosId;
                        this.servicioClienteTelefono.guardar(valor)
                        .subscribe(
                          res => {
                            this.actualizarValoresTelefono()
                          },
                          err => console.log(err)
                          )
                        break;
                    }
              }
            }


              editarclientesTelefonos(ClientesTelefonosData:any){
                let modal = this.modalControllers.create(ClientesTelefonosEditarPage, {ClientesTelefonosData:ClientesTelefonosData})
                modal.present();

                modal.onDidDismiss( data => {
                  if(data){
                    this.editarRegistrosTelefono(ClientesTelefonosData, data);
                  }

                })

              }

            editarRegistrosTelefono(originalTodo: any, modificadoTodo: any){
                const index = this.ClientesTelefonosData.indexOf(originalTodo);

                    this.ClientesTelefonosData = [
                      ...this.ClientesTelefonosData.slice(0,index),
                      modificadoTodo,
                      ...this.ClientesTelefonosData.slice(index + 1)
                    ]
                    modificadoTodo.queHago = "A"
                    modificadoTodo.nombreTabla = "clientesTelefonos"
                    modificadoTodo.name = "dataDynamicCrud"
                   this.servicioClienteTelefono.actualizar(modificadoTodo)
                   .subscribe(
                    res => {
                      this.actualizarValoresTelefono()
                      this.cargarServicioClienteTelefono()
                    },
                    err => {
                      console.log(err)}
                  )
            }


              eliminarClientesTelefonos(todo:any){
                this.ClientesTelefonosData.splice(todo,1);
                this.servicioClienteTelefono.eliminar(this.ClientesTelefonosData)
                let clienteTelefono = []
                clienteTelefono['queHago'] = "E"
                clienteTelefono['name'] = "dataDynamicCrud"
                clienteTelefono['nombreTabla'] = "clientesTelefonos"
                clienteTelefono['clientesTelefonosId'] = todo.clientesTelefonosId
                clienteTelefono['usuariosId'] = this.usuariosId == undefined ? 0 : this.usuariosId;
                this.servicioClienteTelefono.eliminar(clienteTelefono)
                .subscribe(
                  res => {
                    this.actualizarValoresTelefono()
                    this.cargarServicioClienteTelefono()
                  },
                  err => console.log(err)
                )

              }


              cargarServicioClienteTelefono(){
                        this.servicioCliente.buscar()
                        .subscribe((data) => {
                          this.ClientesTelefonos = data
                          this.clientes =  []
                          this.servicioClienteTelefono.buscar()
                            .subscribe((datos)=>{
                              this.ClientesTelefonosData = datos

                              for(var i = 0; i < data.length; i++){
                                var k = 0
                                if(datos.length>0){
                                  for(k < datos.length && datos.length > 0;;){

                                    if(datos[k]['clientesId'] === data[i]['clientesId']){
                                      this.ClientesTelefonosData[k]['nombreCompleto'] =  data[i]['nombreCompleto']
                                    }
                                    if(k + 1< datos.length){
                                      k = k + 1
                                    }else{
                                      break;
                                    }

                                  }
                              }
                              }

                            }, error => {
                              console.log(error)
                            })
                        }, error => {
                          console.log(error)
                        })
                      }
                          valorBuscadoTelefono(dato) {

                            if(dato.clientesId ===this.ClientesTelefonos['clientesId']){
                              return dato.nombreCompleto
                            }
                        }

              actualizarValoresTelefono() {
                this.ClientesTelefonosData = []
                this.numeroTelefono = ""
                this.ClientesTelefonos = []
                this.ClientesTelefonos['clientesId'] = 0
                this.cargarServicioClienteTelefono()

              }
              cerrarSession(){
                this.auth.logout()
                this.navCtrl.setRoot('LoginPage');
              }

    onEvent(event: string, item: any){

      if (event === 'onTextChange') {

        let valor = this.getItems(this.buscar);
        if(valor){
            item = valor
      }
      }
      }

      getItems(event: any): void {
        if(!this.allItems){
          let valores = this.clientes
          this.allItems = valores;
        }
          this.clientes = this.allItems.filter((item) => {
            return item.nombreCompleto.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
          });
    }

    nextPage() {
      this.page+= 100;
    }

    prevPage() {
      if(this.page > 0) {
        this.page-= 100;
      }
    }

    selectItems(item: any) {
    }

  onSearch(valor: string) {
    this.search = valor.trim(); // Actualiza el valor de búsqueda sin espacios extras
    this.paginaActual = 1; // Reinicia la paginación
    this.clientes = []; // Limpia la lista para cargar los nuevos resultados
    this.cargarClientesPaginados(); // Llama al método de carga
  }

  public requestAutocompleteItems = (text: string): Observable<Response> => {
    return this.servicioEntidades.buscarEntidadPorCompania(text, this.companiasId)
  };
  onFileChange(event) {
    const file = event.target.files[0];
    this.foto = file; // Aquí puedes manejar el archivo de foto
  }

  cargarServicioReferenciasFamiliares(){
    this.servicioCliente.buscar()
    .subscribe((data) => {
      this.ClientesTelefonos = data
      this.clientes =  []
      this.servicioClienteTelefono.buscar()
        .subscribe((datos)=>{
          this.ClientesTelefonosData = datos

          for(var i = 0; i < data.length; i++){
            var k = 0
            if(datos.length>0){
              for(k < datos.length && datos.length > 0;;){

                if(datos[k]['clientesId'] === data[i]['clientesId']){
                  this.ClientesTelefonosData[k]['nombreCompleto'] =  data[i]['nombreCompleto']
                }
                if(k + 1< datos.length){
                  k = k + 1
                }else{
                  break;
                }

              }
          }
          }

        }, error => {
          console.log(error)
        })
    }, error => {
      console.log(error)
    })
  }

  selectInputContent(event: any) {
    const inputElement = event.target;
    if(inputElement && inputElement.value) {
      inputElement.setSelectionRange(0, inputElement.value.length);
    }
  }

  buscarCliente(event) {
    this.mostrarGrid = true
    this.buscarTexto = event.value;
    this.identificacion = this.buscarTexto
  }

  async devolverValor(item) {
    this.mostrarGrid = false
    this.buscarTexto = ""
    this.clientesId = Number(item.value)
    const cedula = item.display.split(" - ")[0];
    this.identificacion = cedula
    this.buscarTexto = this.identificacion
    this.limpiarClientesValoresIniciales()
    this.buscarCupoAprobado(this.clientesId)
    this.cargarReferenciasFamiliares(this.clientesId)
    this.buscarClientes(this.clientesId)
    this.buscarClientesReferenciasComerciales(this.clientesId)
    this.buscarClientesReferenciasComercialesVarios(this.clientesId)
    if(this.interesCreditos.length>0) {
      let companiasId = await localStorage.getItem('companiasId')
      this.iniciarLogicaConClientesId(companiasId,this.clientesId)
    }
  }

  async buscarValoresCliente() {
    let companiasId = await this.storages.get('companiasId')
    this.servicio.buscarClientesPorCompaniaAll(companiasId)
    .subscribe(async (data: any)=>{
      let clientes: any = data;
      this.dataclienteFiltro = clientes
    },(error)=> {console.log(error)})
  }

  guardarReferencia(nombre:any,numeroTelefono:any,numeroTelefono2:any,parentezcosId:any,habitoDePago:any,tieneNovedadReferenciaFamiliar:string) {
      let nombreParentezco = this.parentescos.filter((item)=> item.id == parentezcosId)

      let datosClientereferencia: any = {
        nombre : nombre,
        numeroTelefono : numeroTelefono,
        numeroTelefono2 : numeroTelefono2,
        parentezco : nombreParentezco[0].nombre,
        habitoDePago:habitoDePago,
        clientesId:this.clientesId,
        novedad: this.tieneNovedadReferenciaFamiliar,
        queHago: "I",
        nombreTabla: "clientesReferenciasFamiliares",
        name: "dataDynamicCrud",
      }

      if(this.clientesReferenciasFamiliaresId !== undefined && this.clientesReferenciasFamiliaresId >0) {
        datosClientereferencia.queHago = 'A';
        datosClientereferencia.clientesReferenciasFamiliaresId = this.clientesReferenciasFamiliaresId
      }


      this.storages.get('companiasId').then((val) => {
        datosClientereferencia['companiasId']  = val
      this.servicioCliente.guardarReferencia(datosClientereferencia)
        .subscribe(
        res => {
          this.utilidades.mensajeMuestro('Referencias familiares','Guardado Exitosamente!','success')
          this.clientesReferenciasFamiliaresId = undefined
          this.cargarReferenciasFamiliares(this.clientesId)
          this.limpiarReferenciasFamiliares()
        }
         ,
        err => {

          console.log(err)}
        )
      })

  }

  limpiarReferenciasFamiliares() {
    this.nombre = ""
    this.numeroTelefonoReferenciaFamiliar= ""
    this.numeroTelefono2ReferenciaFamiliar= ""
    this.parentezcosId = 0
    this.habitoDePago="S"
    this.tieneNovedadReferenciaFamiliar = 'No'
    this.tieneNovedadReferenciaFamiliar = 'N'
  }


  limpiarReferenciasComercial() {
    this.historico = ""
    this.iniciaCon = ""
    this.fechaDeInicio = ""
    this.actualmenteTiene = ""
  }

  limpiarReferenciasComercialVarios() {
    this.comercio = ""
    this.tieneNovedadTexto = 'No'
    this.tieneNovedad = 'N'
    this.montoAprobado = 0
    this.tieneNovedadComercial = 'N'
    this.tieneNovedadComercialTexto = 'No'
  }


  cargarReferenciasFamiliares(clientesId:any){
    this.storages.get('companiasId').then((val) => {
      this.servicioCliente.buscarReferenciasFamiliares(val,clientesId)
        .subscribe((data) => {
        this.clientesReferenciasFamiliares = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
      }, error => {
        console.log(error)
      })
    })
  }

  buscarClientesReferenciasComerciales(clientesId:any){
    this.storages.get('companiasId').then((val) => {
      this.servicioCliente.buscarClientesReferenciasComerciales(val,clientesId)
        .subscribe((data) => {
        this.clientesreferenciasComerciales = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
      }, error => {
        console.log(error)
      })
    })
  }



  buscarClientes(clientesId:any){
    this.storages.get('companiasId').then((val) => {
      this.servicioCliente.buscarClientes(val,clientesId)
        .subscribe((data) => {
        this.clientesDetalles = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
        if(this.clientesDetalles.length>0) {
          this.cargarDetallesClientes(this.clientesDetalles)
        }
      }, error => {
        console.log(error)
      })
    })
  }

  eliminarReferencia(item) {
    this.utilidades.mensajeConfirmacionDos('Referencias familiares','¿Está Seguro de borrar el registro?','question','Si','No')
    .then((loQuiereBorrar: boolean) => {
     if (loQuiereBorrar) {
       this.buscar =""
       this.allItems = []
       this.servicioCliente.eliminarReferencia(item)
       .subscribe(
         res => {
           this.utilidades.mensajeMuestro('Referencias familiares','Eliminado Exitosamente!','success')
           this.cargarReferenciasFamiliares(this.clientesId)
           this.limpiarReferenciasFamiliares()
          },
         err => this.utilidades.mensajeMuestro('Referencias familiares','No se eliminó el registro','error')
         )
      }
  })}


  asociarParaeditarReferenciaComercial(item:any){
    this.clientesId = item.clientesId
    this.clientesReferenciasComercialesVariosId = item.clientesReferenciasComercialesVariosId
    this.companiasId = item.companiasId
    this.montoAprobado = item.monto
    this.tieneNovedadComercial = item.novedad
    this.comercio = item.comercio
    if(this.tieneNovedadComercial === 'N') {
      this.tieneNovedadComercialTexto = 'NO'
    } else {
      this.tieneNovedadComercialTexto = 'SI'
    }
  }


  asociarParaeditarReferencia(item:any) {
    this.clientesReferenciasFamiliaresId = item.clientesReferenciasFamiliaresId
    this.companiasId = item.companiasId
    this.habitoDePago = item.habitoDePago
    this.nombre = item.nombre
    this.tieneNovedad = item.novedad
    if(this.tieneNovedad === 'S') {
      this.tieneNovedadTextoReferenciaFamiliar = 'Si'
    } else {
      this.tieneNovedadTextoReferenciaFamiliar = 'No'
    }
    this.numeroTelefonoReferenciaFamiliar = item.numeroTelefono
    this.numeroTelefono2ReferenciaFamiliar = item.numeroTelefono2
    let dataParentezco = this.parentescos.filter((values)=> values.nombre == item.parentezco)
    this.parentezcosId = dataParentezco[0].id
  }

  editarReferencia(item) {
    this.clientesReferenciasFamiliaresId = item.clientesReferenciasFamiliaresId
    this.companiasId = item.companiasId
    this.habitoDePago = item.habitoDePago
    this.nombre = item.nombre
    this.tieneNovedad = item.novedad
    this.numeroTelefono = item.numeroTelefono
    this.numeroTelefono2 = item.numeroTelefono2
    this.parentescos = item.parentezco

    this.utilidades.mensajeConfirmacionDos('Referencias familiares','¿Está Seguro de actualizar el registro?','question','Si','No')
    .then((loQuiereBorrar: boolean) => {
     if (loQuiereBorrar) {
       this.buscar =""
       this.allItems = []
       this.servicioCliente.editarReferencia(item)
       .subscribe(
         res => {
           this.utilidades.mensajeMuestro('Referencias familiares','Actualizado Exitosamente!','success')
           this.cargarReferenciasFamiliares(this.clientesId)
           this.limpiarReferenciasFamiliares()
          },
         err => this.utilidades.mensajeMuestro('Referencias familiares','No se actualizo el registro','error')
         )
      }
  })}


  eliminarReferenciaComercial(item) {
    this.utilidades.mensajeConfirmacionDos('Referencias comercial','¿Está Seguro de borrar el registro?','question','Si','No')
    .then((loQuiereBorrar: boolean) => {
     if (loQuiereBorrar) {
       this.buscar =""
       this.allItems = []
       this.servicioCliente.eliminarReferenciaComercial(item)
       .subscribe(
         res => {
           this.utilidades.mensajeMuestro('Referencias comercial','Eliminado Exitosamente!','success')
           this.buscarClientesReferenciasComerciales(this.clientesId)
           this.limpiarReferenciasComercial()
          },
         err => this.utilidades.mensajeMuestro('Referencias comercial','No se eliminó el registro','error')
         )
      }
  })}

  buscarIntereses(companiasId:any){
    this.servicio.buscarIntereses(companiasId).subscribe(async (data: any)=>{
      if(NUBE_AWS) {
        let responsedata = JSON.parse(data['_body']).data[0]
        if(responsedata.length>0) {
          this.interesCreditos = responsedata
          this.creditosBoolean = true
        }
      }
    },(error)=> console.log(error))
  }
  isCredito() {
    if(this.interesCreditos.length>0){
      return 'block'
    } else {
      return 'none'
    }
  }


  cargarDetallesClientes(data:any) {
    if(data.length>0) {
      this.identificacion= data[0].identificacion
      this.buscarTexto = ""
      this.buscarTexto = this.identificacion
      this.primerNombre = data[0].primerNombre
      this.primerApellido = data[0].primerApellido
      this.numeroTelefono = data[0].numeroTelefono
      this.correoElectronico = data[0].correoElectronico
      this.Valordirecciones = data[0].direccion,
      this.numeroTelefono2 = data[0].numeroTelefono2
      this.genero = data[0].genero !== null ? data[0].genero: this.genero
      this.empresa = data[0].empresa
      this.habilitarParaCredito = data[0].habilitarParaCredito !== null ? data[0].habilitarParaCredito: this.habilitarParaCredito
      this.edad = this.calcularEdad(data[0].fechaNacimiento)
      this.cargo = data[0].cargo !== null ? data[0].cargo: this.cargo
      this.salario = data[0].salario !== null ? data[0].salario: this.salario
      let salarioCadena = JSON.stringify(this.salario)
      this.formattedSalario = salarioCadena.replace(/[^0-9]/g, '');
      this.formattedSalario = this.salario.toLocaleString('en-US');
      this.segundoNombre = data[0].segundoNombre !== null ? data[0].segundoNombre: this.segundoNombre
      this.segundoApellido = data[0].segundoApellido !== null ? data[0].segundoApellido: this.segundoApellido
      this.fechaIngreso = data[0].fechaIngreso !== null ? data[0].fechaIngreso: this.fechaIngreso
      this.fechaExpedicion = data[0].fechaExpedicion !== null ? data[0].fechaExpedicion: this.fechaExpedicion
      this.fechaNacimiento = data[0].fechaNacimiento !== null ? this.formatDate(data[0].fechaNacimiento): this.fechaNacimiento
      this.tipoIdentificacion = data[0].tipoIdentificacion !== null ? data[0].tipoIdentificacion: this.tipoIdentificacion
      this.digito = data[0].digito !== null ? data[0].digito: this.digito
      this.estado = data[0].estado !== null ? data[0].estado: this.estado
      this.cargo = data[0].cargo !== null ? data[0].cargo: this.cargo
      this.clientesId = Number( data[0].clientesId)
      this.habilitarParaCredito = data[0].habilitarParaCredito == "1" ? true: false
    }
  }


  formatDate(dateString: string): string {
    return dateString.split('T')[0];
  }

  calcularEdad(fechaNacimiento: string): number {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);

    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();

    // Si el mes actual es menor al mes de nacimiento o es el mismo mes pero el día actual es menor al día de nacimiento,
    // restamos 1 a la edad.
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      edad--;
    }

    return edad;
  }


  limpiarClientes() {
    this.clientes = []
    this.clientesDetalles = []
    this.buscarTexto = ""
    this.identificacion= ""
    this.buscarTexto = ""
    this.primerNombre = ""
    this.empresa = ""
    this.edad = 0
    this.primerApellido = ""
    this.numeroTelefono = ""
    this.numeroTelefono2 = ""
    this.correoElectronico = ""
    this.cargo = ""
    this.salario = 0
    this.formattedSalario = ''
    this.segundoNombre = ""
    this.segundoApellido = ""
    this.fechaIngreso =
    this.fechaExpedicion =
    this.fechaNacimiento = ""
    this.tipoIdentificacion = ""
    this.digito = ""
    this.estado = ""
    this.cargo = ""
    this.clientesId = 0
    this.Valordirecciones = ""
    this.comercio= ""
    this.clientesReferenciasFamiliares = []
    this.clientesreferenciasComerciales = []
    this.clientesreferenciasComercialesVarios = []
    this.habilitarParaCredito = false
    this.cupoAprobado = 0
    this.datosCreditos = []
    this.clienteDescripcion = ''
  }

  guardarReferenciaComercial(loRecomienda:any,iniciaCon:any,fechaDeInicio:any,actualmenteTiene:any) {

    let datosClientereferenciaComercial: any = {
      loRecomienda : loRecomienda,
      iniciaCon : iniciaCon,
      fechaDeInicio : fechaDeInicio,
      actualmenteTiene : actualmenteTiene,
      clientesId:this.clientesId,
      queHago: "I",
      nombreTabla: "clientesReferenciasComerciales",
      name: "dataDynamicCrud",
    }

    this.storages.get('companiasId').then((val) => {
      datosClientereferenciaComercial['companiasId']  = val
    this.servicioCliente.clientesReferenciasComerciales(datosClientereferenciaComercial)
      .subscribe(
      res => {
        this.utilidades.mensajeMuestro('Referencias comercial','Guardado Exitosamente!','success')
        this.buscarClientesReferenciasComerciales(this.clientesId)
        this.limpiarReferenciasComercial()
      }
       ,
      err => {

        console.log(err)}
      )
    })

}


actualizar(){

  let fechaExped = this.fechaExpedicion
  fechaExped = this.servicioCliente.formatearCadena(this.fechaExpedicion)
  let fechaIng = this.fechaIngreso
  fechaIng  = this.servicioCliente.formatearCadena(this.fechaIngreso)
  if(fechaIng ="--"){
    fechaIng = "1900-01-01"
    fechaExped = "1900-01-01"
    this.estado = "A"
  }

  let datosCliente: any = {
    tipoIdentificacion : this.tipoIdentificacion.toUpperCase(),
    identificacion : this.identificacion,
    digito : this.digito,
    fechaExpedicion : fechaExped,
    primerApellido : this.primerApellido,
    numeroTelefono : this.numeroTelefono,
    numeroTelefono2: this.numeroTelefono2,
    segundoApellido : this.segundoApellido,
    primerNombre : this.primerNombre,
    segundoNombre : this.segundoNombre,
    nombreCompleto : `${this.primerNombre} ${this.segundoNombre} ${this.primerApellido} ${this.segundoApellido} ` ,
    fechaIngreso : fechaIng,
    estado : this.estado,
    direccion : this.Valordirecciones,
    queHago: "A",
    nombreTabla: "clientes",
    name: "dataDynamicCrud",
    correoElectronico: this.correoElectronico,
    entidadesId: this.entidadesId && this.entidadesId.length > 0 ? this.entidadesId[0].value : 0,
    fechaNacimiento: this.fechaNacimiento == undefined || this.fechaNacimiento == null ? '1900-01-01' : new Date(this.fechaNacimiento),
    edad: this.edad == undefined ? 0 : this.edad,
    habilitarParaCredito: this.habilitarParaCredito === true ? '1' : '0',
    empresa: this.empresa == undefined ? '' : this.empresa,
    cargo: this.cargo == undefined ? '' : this.cargo,
    salario: this.salario == undefined ? 0 : this.salario,
    clientesId:this.clientesId
  }
  this.storages.get('companiasId').then((val) => {
    datosCliente['companiasId']  = val
    datosCliente['usuariosId'] = this.usuariosId == undefined ? 0 : this.usuariosId;
    let identificacion = datosCliente.identificacion
  this.servicioCliente.guardar(datosCliente)
    .subscribe(
    (res:any) => {
      let buscarCliente = this.interesCreditos.length>0 ? true : false
      if(buscarCliente) {
        this.servicioCliente.buscarClientesPorIdentificacion(val,identificacion)
        .subscribe(
        (datos:any) => {
          this.clientesDetalles = !NUBE_AWS ? datos : JSON.parse(datos['_body']).data[0]
          if(this.clientesDetalles.length>0) {
            this.cargarDetallesClientes(this.clientesDetalles)
          }
          this.utilidades.mensajeMuestro('CLIENTES','Guardado Exitosamente!','success')
          this.cargarServicioCliente()
        },(err)=> console.log(err))
      } else{
        this.limpiarClientes()
        this.utilidades.mensajeMuestro('CLIENTES','Guardado Exitosamente!','success')
        this.cargarServicioCliente()
      }
    },
    err => {

      console.log(err)}
    )
  })

  this.tipoIdentificacion =""
  this.identificacion =""
  this.digito =""
  this.fechaExpedicion =""
  this.primerApellido =""
  this.segundoApellido =""
  this.primerNombre =""
  this.segundoNombre =""
  this.nombreCompleto =""
  this.fechaIngreso =""
  this.estado =""
  this.Valordirecciones = ""
  this.numeroTelefono = ""
  this.numeroTelefono2 = ""
  this.correoElectronico = ""
  this.fechaNacimiento=""
  this.edad=0
  this.foto=""
  this.genero=""
  this.habilitarParaCredito=false
  this.empresa=""
  this.cargo=""
  this.salario=0
  this.formattedSalario = ''

  setTimeout(()=>{
    this.cargarServicioCliente()
  },2000)
  }

  limpiarClientesValoresIniciales() {
    this.paginaActual = 1
    this.clientes = []
    this.clientesDetalles = []
    this.buscarTexto = ""
    this.primerNombre = ""
    this.empresa = ""
    this.edad = 0
    this.primerApellido = ""
    this.numeroTelefono = ""
    this.numeroTelefono2 = ""
    this.correoElectronico = ""
    this.cargo = ""
    this.salario = 0
    this.formattedSalario = ''
    this.segundoNombre = ""
    this.segundoApellido = ""
    this.fechaIngreso =
    this.fechaExpedicion =
    this.fechaNacimiento = ""
    this.tipoIdentificacion = ""
    this.digito = ""
    this.estado = ""
    this.cargo = ""
    this.Valordirecciones = ""
    this.clientesReferenciasFamiliares = []
    this.clientesreferenciasComerciales = []
    this.clientesreferenciasComercialesVarios = []
    this.comercio = ""
  }


  eliminarReferenciaComercialesVarios(item) {
    this.utilidades.mensajeConfirmacionDos('Referencias comercial','¿Está Seguro de borrar el registro?','question','Si','No')
    .then((loQuiereBorrar: boolean) => {
     if (loQuiereBorrar) {
       this.buscar =""
       this.allItems = []
       this.servicioCliente.eliminarReferenciaComercialVarios(item)
       .subscribe(
         res => {
           this.utilidades.mensajeMuestro('Referencias comercial','Eliminado Exitosamente!','success')
           this.buscarClientesReferenciasComercialesVarios(this.clientesId)
           this.limpiarReferenciasComercialVarios()
          },
         err => this.utilidades.mensajeMuestro('Referencias comercial','No se eliminó el registro','error')
         )
      }
  })}



  guardarReferenciaComercialesVarios(comercio: string, montoAprobado: number, tieneNovedadComercial: string) {

    let datosClientereferenciaComercialVarios: any = {
      comercio : comercio,
      clientesId:this.clientesId,
      queHago: "I",
      monto:montoAprobado,
      novedad:tieneNovedadComercial,
      nombreTabla: "clientesReferenciasComercialesVarios",
      name: "dataDynamicCrud",
    }

    if(this.clientesReferenciasComercialesVariosId !== undefined && this.clientesReferenciasComercialesVariosId > 0){
      datosClientereferenciaComercialVarios.queHago = 'A'
      datosClientereferenciaComercialVarios.clientesReferenciasComercialesVariosId = this.clientesReferenciasComercialesVariosId
    }

    this.storages.get('companiasId').then((val) => {
      datosClientereferenciaComercialVarios['companiasId']  = val
    this.servicioCliente.clientesReferenciasComercialesVarios(datosClientereferenciaComercialVarios)
      .subscribe(
      res => {
        this.utilidades.mensajeMuestro('Referencias comercial','Guardado Exitosamente!','success')
        this.clientesReferenciasComercialesVariosId = undefined
        this.buscarClientesReferenciasComercialesVarios(this.clientesId)
        this.limpiarReferenciasComercialVarios()
      }
       ,
      err => {

        console.log(err)}
      )
    })

}

buscarClientesReferenciasComercialesVarios(clientesId:any){
  this.storages.get('companiasId').then((val) => {
    this.servicioCliente.buscarClientesReferenciasComercialesVarios(val,clientesId)
      .subscribe((data) => {
      this.clientesreferenciasComercialesVarios = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
    }, error => {
      console.log(error)
    })
  })
}




async cargarClientesPaginados(infiniteScroll?) {
  let companiasId = await localStorage.getItem('companiasId');

  if (this.paginaActual <= this.totalPaginas) {
    this.servicioCliente.buscarClientesPorEmpresaPaginadoInfinito(companiasId, this.paginaActual, this.cantidadPorPagina, this.search)
      .subscribe((data: any) => {
        const clientesPagina = !NUBE_AWS ? data : JSON.parse(data['_body']).data;

        // Agrega los nuevos clientes sin sobrescribir los anteriores
        let clientesCopia = [...this.clientes, ...clientesPagina];
        this.clientes = []

        this.clientes = clientesCopia.reduce((acc, clientes) => acc.concat(clientes), []);
        this.cd.detectChanges();
        this.paginaActual++;

        if (infiniteScroll) {
          infiniteScroll.complete(); // Indica que terminó la carga
        }
      }, error => {
        console.log(error);
        if (infiniteScroll) {
          infiniteScroll.complete();
        }
      });
  } else {
    if (infiniteScroll) {
      infiniteScroll.enable(false); // Deshabilita el scroll cuando ya no hay más datos
    }
  }
}

toggleNovedad() {
  this.tieneNovedad = this.tieneNovedad === 'N' ? 'S' : 'N';
  if(this.tieneNovedad === 'N') {
    this.tieneNovedadTexto = 'NO'
  } else {
    this.tieneNovedadTexto = 'SI'
  }
}

toggleNovedadComercial() {
  this.tieneNovedadComercial = this.tieneNovedadComercial === 'N' ? 'S' : 'N';
  if(this.tieneNovedadComercial === 'N') {
    this.tieneNovedadComercialTexto = 'NO'
  } else {
    this.tieneNovedadComercialTexto = 'SI'
  }
}

toggleNovedadReferenciaFamiliar() {
  this.tieneNovedadReferenciaFamiliar = this.tieneNovedadReferenciaFamiliar === 'N' ? 'S' : 'N';
  if(this.tieneNovedadReferenciaFamiliar === 'N') {
    this.tieneNovedadTextoReferenciaFamiliar = 'NO'
  } else {
    this.tieneNovedadTextoReferenciaFamiliar = 'SI'
  }
}

async buscarCupoAprobado(clientesId:any) {
  let companiasId = await localStorage.getItem('companiasId')
  let data:any = await this.push.buscarCupoAprobado(companiasId,clientesId)
  let response = JSON.parse(data['_body']).data[0]
  if(response !== null && response[0] && response[0].cupoAprobado !== null) {
    this.cupoAprobado =  response[0].cupoAprobado
  }
}

validateDate() {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!regex.test(this.fechaNacimiento)) {
    alert('Por favor, ingresa una fecha válida en el formato YYYY-MM-DD');
    this.fechaNacimiento = '';
  }
}

onFocus() {
  this.isFocused = true;
}

onBlur() {
  this.isFocused = false;
  this.validateDate();
}


formatSalary() {
  if (this.formattedSalario) {
    // Remover cualquier carácter no numérico antes de formatear
    const numericValue = this.formattedSalario.replace(/[^0-9]/g, '');
    // Guardar el valor numérico sin formatear
    this.salario = parseFloat(numericValue);
    // Formatear el valor con separadores de miles
    this.formattedSalario = this.salario.toLocaleString('en-US');
  }
}

updateSalary(event: any) {
  // Actualizar el valor del salario mientras el usuario escribe
  this.formattedSalario = event.target.value.replace(/[^0-9]/g, '');
}

async iniciarLogicaConClientesId(companiasId,clientesIdCallcenter: any) {
  this.mostrarGrid = false
  this.buscarTexto = ""
  this.clientesId = Number(clientesIdCallcenter)
  this.identificacion = this.clientesId.toString()
  this.limpiarClientesValoresIniciales()
  this.buscarCupoAprobado(this.clientesId)
  this.cargarReferenciasFamiliares(this.clientesId)
  this.buscarClientes(this.clientesId)
  this.buscarClientesReferenciasComerciales(this.clientesId)
  this.buscarClientesReferenciasComercialesVarios(this.clientesId)
  this.clienteDescripcion = ''
  if(clientesIdCallcenter) {
    let data = await this.servicio.buscarResumenPorCliente(companiasId,clientesIdCallcenter)
    let response = data.json()
    let datosAdicionales = response.data[0]
    if(datosAdicionales.length > 0) {
      this.datosCreditos = datosAdicionales
    }

    let dataClienteDescripcion = await this.servicio.buscarDescripcionCliente(companiasId,clientesIdCallcenter)
    let responseClienteDescripcion = dataClienteDescripcion.json()
    let datosAdicionalesClienteDescripcion = responseClienteDescripcion.data[0]
    if(datosAdicionalesClienteDescripcion.length > 0) {
      this.clienteDescripcion = datosAdicionalesClienteDescripcion[0].descripcion
    }

  }
}

aprobar(tieneCupoAprobado:any,montoAprobadoFinal:any,descripcionCupoAprobado:any) {
  this.guardarCupo(tieneCupoAprobado,montoAprobadoFinal,descripcionCupoAprobado)
}

toggleCupoDisponible() {
  this.tieneCupoAprobado = this.tieneCupoAprobado === 'N' ? 'S' : 'N';
  if(this.tieneCupoAprobado === 'N') {
    this.tieneCupoAprobadoTexto = 'NO'
    this.montoAprobadoFinal = 0
  } else {
    this.tieneCupoAprobadoTexto = 'SI'
  }
}

async guardarCupo(tieneCupoAprobado:any,montoAprobadoFinal:any,descripcionCupoAprobado:any) {
    await this.actualizaraccionesEstadosGestionIndividualPorClienteIdDesceClientes(tieneCupoAprobado,montoAprobadoFinal,descripcionCupoAprobado);
}

async actualizaraccionesEstadosGestionIndividualPorClienteIdDesceClientes(tieneCupoAprobado:any,montoAprobadoFinal:any,descripcionCupoAprobado:any) {
  let companiasId = await localStorage.getItem('companiasId')
  if(this.clientesId && companiasId) {
    let datos = this.callcenterProvider.actualizaraccionesEstadosGestionIndividualPorClienteIdDesceClientes(companiasId,this.clientesId
      ,tieneCupoAprobado,montoAprobadoFinal,descripcionCupoAprobado)
    let response = (await datos).json()
    if(response && response.data && response.data[0].length>0) {
      let valores = response.data[0]
      console.log(valores)
      this.iniciarLogicaConClientesId(companiasId,this.clientesId)
      return
    }
  }
}

descargarExcel() {
  if(this.clientes.length>0) {
    this.servicioDescargar.exportToExcel(this.clientes, 'clientes')
  }
}

}



// WEBPACK FOOTER //
// ./src/pages/clientes/clientes.ts